export enum FeatureFlag {
    EPISODES_OF_CARE = 'EPISODES_OF_CARE',
    ORDERS = 'ORDERS',

    // Booking Flow
    SHOW_MAP_IN_BOOKING_FLOW = 'SHOW_MAP_IN_BOOKING_FLOW',

    // Partner Axle V2 Features
    ALL_VISITS_MAP = 'ALL_VISITS_MAP',
    DASHBOARD_CLINICIAN_HOME_PINS_ON_MAPS = 'DASHBOARD_CLINICIAN_HOME_PINS_ON_MAPS',
    DASHBOARD_CLINICIAN_DETAILS_HEADER_V2 = 'DASHBOARD_CLINICIAN_DETAILS_HEADER_V2',
    CREATE_EPISODE_VISIT_FLOW = 'CREATE_EPISODE_VISIT_FLOW',
    CREATE_URGENT_VISIT_FLOW = 'CREATE_URGENT_VISIT_FLOW',
    DASHBOARD_ALL_EPISODES_VIEW = 'DASHBOARD_ALL_EPISODES_VIEW',
    CLINICIAN_NOT_RECOMMENDED = 'CLINICIAN_NOT_RECOMMENDED',
    DASHBOARD_CARE_TEAM_RECOMMENDATION_FLOW = 'DASHBOARD_CARE_TEAM_RECOMMENDATION_FLOW',
    DASHBOARD_HOME_VIEW = 'DASHBOARD_HOME_VIEW',
    DASHBOARD_LIVE_VIEW_SIDEBAR = 'DASHBOARD_LIVE_VIEW_SIDEBAR',
    DASHBOARD_TAG_FILTERS_ON_HOMEPAGE = 'DASHBOARD_TAG_FILTERS_ON_HOMEPAGE',
    GLOBAL_NAVIGATION_V2 = 'GLOBAL_NAVIGATION_V2',
    GLOBAL_PATIENT_COMMS = 'GLOBAL_PATIENT_COMMS',
    PATIENT_DETAILS_PAGE_V2 = 'PATIENT_DETAILS_PAGE_V2',
    PATIENT_INTAKE_CAPACITY_PAGE = 'PATIENT_INTAKE_CAPACITY_PAGE',
    PATIENTS_LIST_PAGE_SHOW_BENEFIT_ADMIT_COLUMNS = 'PATIENTS_LIST_PAGE_SHOW_BENEFIT_ADMIT_COLUMNS',
    DASHBOARD_PATIENT_TAGS_IN_TABLES = 'DASHBOARD_PATIENT_TAGS_IN_TABLES',
    PATIENTS_LIST_PAGE_V2 = 'PATIENTS_LIST_PAGE_V2',
    DASHBOARD_TAG_FILTERS_ON_PATIENTS_PAGE = 'DASHBOARD_TAG_FILTERS_ON_PATIENTS_PAGE',
    REASSIGN_VISITS_FLOW_V2 = 'REASSIGN_VISITS_FLOW_V2',
    DASHBOARD_VISIT_REASSIGNMENT_FLOW = 'DASHBOARD_VISIT_REASSIGNMENT_FLOW',
    DASHBOARD_BULK_VISIT_REASSIGNMENT = 'DASHBOARD_BULK_VISIT_REASSIGNMENT',
    // Renders the new decisionSupport.visitAssignment flow (visits only) on the
    // assignment surfaces; falls back to the legacy DS assignment screen when off.
    DS_VISIT_ASSIGNMENT_REWRITE = 'DS_VISIT_ASSIGNMENT_REWRITE',
    CLINICIANS_LIST_PAGE_V2 = 'CLINICIANS_LIST_PAGE_V2',
    VISITS_LIST_PAGE_V2 = 'VISITS_LIST_PAGE_V2',
    VISIT_TABLES_USING_DATA_GRID_IN_V2 = 'VISIT_TABLES_USING_DATA_GRID_IN_V2',
    HIGHLIGHT_LINKED_VISIT = 'HIGHLIGHT_LINKED_VISIT',

    // Bulk Cancellation
    DASHBOARD_BULK_CANCELLATION_ALL_VISITS = 'DASHBOARD_BULK_CANCELLATION_ALL_VISITS',
    DASHBOARD_BULK_CANCELLATION_PATIENT_EPISODE_VIEW = 'DASHBOARD_BULK_CANCELLATION_PATIENT_EPISODE_VIEW',
    DASHBOARD_BULK_REASSIGNMENT_PATIENT_EPISODE_VIEW = 'DASHBOARD_BULK_REASSIGNMENT_PATIENT_EPISODE_VIEW',

    // Edit Visit Services
    DASHBOARD_EDIT_VISIT_SERVICES_DIALOG = 'DASHBOARD_EDIT_VISIT_SERVICES_DIALOG',

    // Inline service-type (Visit Type) override in the reassignment flow
    DASHBOARD_REASSIGN_SERVICE_TYPE_OVERRIDE = 'DASHBOARD_REASSIGN_SERVICE_TYPE_OVERRIDE',

    // Show/hide canceled visits in the patient episode view visit table
    DASHBOARD_TOGGLE_CANCELED_VISITS = 'DASHBOARD_TOGGLE_CANCELED_VISITS',

    // Microsoft OAuth
    MICROSOFT_OAUTH = 'MICROSOFT_OAUTH',

    // Bulk Cancellation
    DASHBOARD_BULK_CANCELLATION_WORK_QUEUE = 'DASHBOARD_BULK_CANCELLATION_WORK_QUEUE',

    // Hides the clinicians column on the Territories page and omits clinicians from its query.
    DASHBOARD_HIDE_CLINICIANS_FROM_TERRITORY_LIST = 'DASHBOARD_HIDE_CLINICIANS_FROM_TERRITORY_LIST',

    // Wide-table treatment on the All Visits table.
    DASHBOARD_TABLE_HORIZONTAL_BUTTONS = 'DASHBOARD_TABLE_HORIZONTAL_BUTTONS',
    DASHBOARD_TABLE_PINNED_ACTIONS = 'DASHBOARD_TABLE_PINNED_ACTIONS',
    // Two-sided matching criteria (patient/clinician needs and attributes).
    MATCHING_CRITERIA = 'MATCHING_CRITERIA',

    DASHBOARD_SHOW_DS_DISPLAY_VALUE_IN_CELLS = 'DASHBOARD_SHOW_DS_DISPLAY_VALUE_IN_CELLS',

    // Alt/Option + drag on the clinician schedules calendar creates a shift block
    // instead of a shift.
    DASHBOARD_SHIFT_BLOCK_DRAG_SUPPORT = 'DASHBOARD_SHIFT_BLOCK_DRAG_SUPPORT',
}
